import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import { ANALYTICS_IDENTIFY_USER } from '@perpay-web/fintech/constants/actionTypes';
import { getCordovaApp } from '@perpay-web/fintech/utils/cordovaUtils';

/** @deprecated should be removed once enough users are no longer on the cordova app */
export const initCordovaOnIdentify = (action$) =>
    action$.pipe(
        ofType(ANALYTICS_IDENTIFY_USER),
        mergeMap((action) => {
            const { email, first_name: firstName, created } = action.payload;
            getCordovaApp().then((CordovaApp) => {
                CordovaApp.setUser(email, firstName, created);
            });
            return [];
        }),
    );
